// 인코딩 감지/디코드 — 순수 함수 (기획서 8.4.3, 13장 Worker 이전 대상)
// 입력: ArrayBuffer  /  출력: NFC 정규화된 문자열
// DOM·IndexedDB·전역 상태 접근 금지.

// U+FFFD(replacement char) 비율로 디코드 실패를 판정.
function replacementRatio(text) {
  if (!text) return 0;
  let bad = 0;
  for (let i = 0; i < text.length; i++) {
    if (text.charCodeAt(i) === 0xfffd) bad++;
  }
  return bad / text.length;
}

function tryDecode(buffer, label) {
  try {
    // fatal:false → 깨진 바이트는 U+FFFD 로 치환되므로 비율로 판정 가능
    const dec = new TextDecoder(label, { fatal: false });
    return dec.decode(buffer);
  } catch {
    return null; // 해당 인코딩을 브라우저가 지원하지 않음
  }
}

/**
 * ArrayBuffer → 텍스트.
 * 1) UTF-8 디코드
 * 2) U+FFFD 다수면 EUC-KR(=CP949 상위호환) 재시도 (기획서 8.4.3)
 * 3) 결과를 NFC 정규화 (offset 계산 일관성 — 기획서 0.6, 8.2.0)
 * @returns {{ text: string, encoding: string }}
 */
export function decodeTextBuffer(buffer) {
  // BOM 처리: UTF-8 BOM 이 있으면 명백히 UTF-8
  const head = new Uint8Array(buffer, 0, Math.min(3, buffer.byteLength));
  const hasUtf8Bom = head.length >= 3 && head[0] === 0xef && head[1] === 0xbb && head[2] === 0xbf;

  let text = tryDecode(buffer, 'utf-8') ?? '';
  let encoding = 'utf-8';

  if (!hasUtf8Bom && replacementRatio(text) > 0.01) {
    // 한국어 레거시 인코딩 후보. 브라우저별 라벨 차이를 고려해 순차 시도.
    for (const label of ['euc-kr', 'cp949', 'ks_c_5601-1987', 'windows-949']) {
      const alt = tryDecode(buffer, label);
      if (alt != null && replacementRatio(alt) < replacementRatio(text)) {
        text = alt;
        encoding = label;
        if (replacementRatio(text) < 0.001) break;
      }
    }
  }

  // NFC 정규화 — 이후 모든 글자 인덱스(start/end, globalOffset)의 기준
  const normalized = typeof text.normalize === 'function' ? text.normalize('NFC') : text;
  return { text: normalized, encoding };
}
